/*eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
// import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/Button';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Key from '../../clientVariables.json';
// import ToastMessage from '../../components/ToastMessage';

const AddCompanyContact = (props) => {
  const { showAddContactPopup, companyDetails, getCOmpanyContacts, handleAddContactPopupClose } = props;
  const formikRef = useRef();

  const addContactSubmit = (fields) => {

    fetch(`${Key.domain_crm}/company/add_contact_`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: fields.contactName,
        role: fields.designation,
        email: fields.email,
        phone: fields.mobile,
        linkedinURL: fields.linkedInUrl,
        companyID: companyDetails.id,
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        if (resdata?.success === 1) {
          const msg = resdata?.data;
          // toast(<ToastMessage message={msg} />);
          handleAddContactPopupClose(false);
          getCOmpanyContacts(companyDetails.id, 0);
        } else {
          const msg = resdata?.error || resdata?.data || 'Something went wrong';
          // toast(<ToastMessage message={msg} />);
        }
      });
    });
    //   }
  };
  return (
    <div>
      <Modal
        size="md"
        show={showAddContactPopup}
        onHide={() => handleAddContactPopupClose(false)}
        centered
        // style={{ marginLeft: "8%", marginTop:"100px"}}
        style={{ paddingTop: '80px' }}
      >
        <Modal.Header closeButton>
          Add Contact for <span style={{ fontWeight: '500', marginLeft: '8px' }}>{companyDetails.name}</span>
        </Modal.Header>

        <Modal.Body>
          <Container>
            {/* <Form  onSubmit={addContactSubmit} >
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  name="name"
                  onChange={(e) => setContactName(e.target.value)}
                  value={contactName}
                />

              </Form.Group>
              <Form.Group>
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter contact role"
                  name="role"
                  onChange={(e) => setContactRole(e.target.value)}
                  value={contactRole}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email"
                  name="email"
                  onChange={(e) => setContactEmail(e.target.value)}
                  value={contactEmail}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Linkedin URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Linkedin url"
                  name="linkedin"
                  onChange={(e) => setContactLinkedin(e.target.value)}
                  value={contactLinkedin}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter phone number"
                  name="mobile"
                  onChange={(e) => setContactPhone(e.target.value)}
                  value={contactPhone}
                />
              </Form.Group>

              <Button
              type="submit"
                style={{ float: 'right', marginTop: '10px' }}
                // onClick={(e) => {
                //   addContactSubmit();
                // }}
              >
                Submit
              </Button>
            </Form> */}
            <Formik
              innerRef={formikRef}
              initialValues={{
                contactName: '',
                email: '',
                mobile: '',
                linkedInUrl: '',
                designation: '',
              }}
              validationSchema={Yup.object().shape({
                contactName: Yup.string().required('Contact Name is required').matches(
                    /^[a-zA-Z\s]+$/,
                    // /^[a-zA-Z0-9\s.+-]+$/,
                    "Contact name invalid "
                ),
                email: Yup.string().email('Email is invalid').required('Email is required'),
                designation: Yup.string().required('Role is required'),
                linkedInUrl: Yup.string().required('Linkedin URL is required'),
              })}
              onSubmit={(fields) => {
                addContactSubmit(fields);
              }}
              render={({ errors, status, touched, values, handleChange }) => (
                <div className="container">
                  <Form autoComplete="off">
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group" id="_form-group">
                          <label htmlFor='contactName'>
                            Contact Name <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Field
                          id='contactName'
                            name="contactName"
                            type="text"
                            placeholder="Contact Name"
                            className={
                              'form-control mb-2' + (errors.contactName && touched.contactName ? ' is-invalid' : '')
                            }
                          />
                          <ErrorMessage name="contactName" component="div" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group" id="_form-group">
                          <label>
                            Email <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Field
                            name="email"
                            type="text"
                            placeholder="Email"
                            className={'form-control mb-2' + (errors.email && touched.email ? ' is-invalid' : '')}
                          />
                          <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group" id="_form-group">
                          <label>
                            Role <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Field
                            name="designation"
                            type="text"
                            placeholder="Role"
                            className={
                              'form-control mb-2' + (errors.designation && touched.designation ? ' is-invalid' : '')
                            }
                          />
                          <ErrorMessage name="designation" component="div" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group" id="_form-group">
                          <label>Mobile</label>
                          <Field
                            name="mobile"
                            type="text"
                            placeholder="xxxxxxxxxx"
                            className={'form-control mb-2' + (errors.mobile && touched.mobile ? ' is-invalid' : '')}
                          />
                          <ErrorMessage name="mobile" component="div" className="invalid-feedback" />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-group" id="_form-group">
                          <label>
                            LinkedIn URL <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Field
                            name="linkedInUrl"
                            type="text"
                            placeholder="Linkedin URL"
                            className={
                              'form-control mb-2' + (errors.linkedInUrl && touched.linkedInUrl ? ' is-invalid' : '')
                            }
                          />
                          <ErrorMessage name="linkedInUrl" component="div" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <br />
                      <Button
                        variant="Primary"
                        type="submit"
                        style={{ background: 'blue', color: '#ffff', marginRight: '30px' }}
                      >
                        Add
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
            />
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddCompanyContact;
